import { render, staticRenderFns } from "./arrowSortRightIcon.vue?vue&type=template&id=6ccabc4b&"
import script from "./arrowSortRightIcon.vue?vue&type=script&lang=js&"
export * from "./arrowSortRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports